'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HotSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotSvg(props) {
    var width = props.width,
        height = props.height,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { width: width, height: height, viewBox: '0 0 24 27', xmlns: 'http://www.w3.org/2000/svg',
            'data-hook': 'wixrest-menus-icon-full-hot', role: 'img', 'aria-labelledby': 'fullimgHot' },
        _react2.default.createElement(
            'title',
            { id: 'fullimgHot' },
            i18n.get('openrest_menubuilderv3_dishlabels_hot') || 'hot'
        ),
        _react2.default.createElement(
            'g',
            { fill: primaryColor },
            _react2.default.createElement('path', {
                d: 'M10.9 9.538c.25-.082.58.07.667.35.034.104.786 2.598-1.122 5.484-.075.113-.186.19-.31.22-.14.04-.298.02-.43-.068-.247-.163-.314-.495-.152-.742 1.614-2.44 1.02-4.492.995-4.578-.087-.28.07-.58.353-.666m.105-5.324c-.505-.038-.96.127-1.32.473C9.02 5.33 8.83 6.5 8.78 7.264c-1.286.022-2.04.505-2.453.946-.77.82-1.015 2.09-.73 3.775.033.205.075.42.12.643.174.872.37 1.858.177 2.918-.466 2.567-2.166 3.402-3.53 4.072-.932.456-1.985.973-1.65 2.1.078.26.33.72 1.122.833.49.072 1.142-.002 1.877-.2 2.208-.59 5.154-2.294 6.615-4.557 2.176-3.364 2.94-6.68 1.996-8.653-.31-.65-.945-1.434-2.212-1.743.04-.67.196-1.45.505-1.75.086-.084.168-.11.295-.103.363.03.688-.25.714-.615.03-.37-.25-.69-.617-.716M21.336 9.455c.247-.083.578.07.666.348.034.106.786 2.6-1.122 5.486-.075.112-.186.187-.31.22-.14.038-.298.018-.43-.07-.248-.163-.314-.495-.152-.74 1.614-2.442 1.02-4.493.994-4.58-.086-.28.072-.578.354-.665m.104-5.325c-.505-.037-.96.128-1.32.474-.668.643-.855 1.812-.907 2.577-1.286.023-2.04.505-2.453.947-.77.82-1.016 2.09-.732 3.775.034.205.077.42.122.643.174.87.37 1.858.177 2.918-.466 2.567-2.167 3.4-3.53 4.07-.932.458-1.985.975-1.65 2.1.078.263.33.722 1.122.835.488.07 1.14-.004 1.876-.2 2.207-.592 5.152-2.295 6.614-4.558 2.175-3.364 2.94-6.68 1.995-8.653-.312-.65-.945-1.435-2.213-1.743.042-.67.196-1.452.506-1.75.085-.084.168-.112.295-.103.363.03.688-.248.714-.615.028-.368-.25-.687-.617-.715' })
        )
    );
}

HotSvg.displayName = 'HotSvg';
HotSvg.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
HotSvg.defaultProps = {
    width: 24,
    height: 27,
    primaryColor: '#c4270e'
};